import { render, staticRenderFns } from "./releasetype-modal.vue?vue&type=template&id=5ae5d2a8&"
import script from "./releasetype-modal.vue?vue&type=script&lang=tsx&"
export * from "./releasetype-modal.vue?vue&type=script&lang=tsx&"
import style0 from "./releasetype-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports